module.exports = __webpack_public_path__ + "static/media/house-day.6a49d219.svg";